// import L_REACT_ROUTER from "../assets/img/skills/react-router.svg";
// import L_DJANGO from "../assets/img/skills/django.svg";
// import L_GITHUB_PAGES from "../assets/img/skills/github.svg";
// import L_PYTHON from "../assets/img/skills/python.svg";

import * as L_IMG from "../assets/img/skills/index";

export const skills = {
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_IMG.L_HTML5,
      skillName: "HTML5",
    },
    {
      link:
        "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_IMG.L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_IMG.L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://sass-lang.com/",
      imgAltText: "Sass",
      imgSrc: L_IMG.L_SASS,
      skillName: "Sass",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_IMG.L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_IMG.L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://facebook.github.io/flux/",
      imgAltText: "Flux",
      imgSrc: L_IMG.L_FLUX,
      skillName: "Flux",
    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: L_IMG.L_REDUX,
      skillName: "Redux",
    },
    {
      link: "https://angular.io/",
      imgAltText: "Angular",
      imgSrc: L_IMG.L_ANGULAR,
      skillName: "Angular",
    },
    /*     {
      link: "https://reacttraining.com/react-router/",
      imgAltText: "React Router",
      imgSrc: L_REACT_ROUTER,
      skillName: "React Router",
    }, */
    {
      link: "https://material-ui.com/",
      imgAltText: "Material-UI",
      imgSrc: L_IMG.L_MATERIALUI,
      skillName: "Material-UI",
    },
    {
      link: "https://react-bootstrap.github.io/",
      imgAltText: "React Bootstrap",
      imgSrc: L_IMG.L_REACT_BOOTSTRAP,
      skillName: "React Bootstrap",
    },
    {
      link: "https://styled-components.com/",
      imgAltText: "styled-components",
      imgSrc: L_IMG.L_STYLED_COMPONENTS,
      skillName: "styled-components",
    },
  ],

  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_IMG.L_NODE_JS,
      skillName: "Node.js",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_IMG.L_EXPRESS,
      skillName: "Express",
    },
    /*     {
      link: "https://www.djangoproject.com/",
      imgAltText: "Django",
      imgSrc: L_DJANGO,
      skillName: "Django",
    },
    {
      link: "https://flask.palletsprojects.com/",
      imgAltText: "Flask",
      imgSrc: L_FLASK,
      skillName: "Flask",
    }, */
  ],
  hostingPlatforms: [
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_IMG.L_HEROKU,
      skillName: "Heroku",
    },
    {
      link: "https://firebase.google.com/?hl=es",
      imgAltText: "Firebase",
      imgSrc: L_IMG.L_FIREBASE,
      skillName: "Firebase",
    },
    {
      link: "https://pages.github.com/",
      imgAltText: "GitHub Pages",
      imgSrc: L_IMG.L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
    {
      link: "https://www.netlify.com/",
      imgAltText: "Netlify",
      imgSrc: L_IMG.L_NETLIFY,
      skillName: "Netlify",
    },
  ],
  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_IMG.L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_IMG.L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    /*     {
      link: "https://www.python.org/",
      imgAltText: "Python",
      imgSrc: L_PYTHON,
      skillName: "Python",
    },
    {
      link: "https://golang.org/",
      imgAltText: "Golang",
      imgSrc: L_GOLANG,
      skillName: "Golang",
    }, */
  ],
  databases: [
    /*     {
      link: "https://www.postgresql.org/",
      imgAltText: "PostgreSQL",
      imgSrc: L_POSTGRESQL,
      skillName: "PostgreSQL",
    }, */
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_IMG.L_MONGODB,
      skillName: "MongoDB",
    },
    {
      link: "https://www.mysql.com/",
      imgAltText: "MySQL",
      imgSrc: L_IMG.L_MYSQL,
      skillName: "MySQL",
    },
  ],
  testing: [
    {
      link: "https://jestjs.io/",
      imgAltText: "Jest",
      imgSrc: L_IMG.L_JEST,
      skillName: "Jest",
    },
    {
      link: "https://jasmine.github.io/",
      imgAltText: "Jasmine",
      imgSrc: L_IMG.L_JASMINE,
      skillName: "Jasmine",
    },
    {
      link: "https://www.chaijs.com/",
      imgAltText: "Chai",
      imgSrc: L_IMG.L_CHAI,
      skillName: "Chai",
    },
    {
      link: "https://sinonjs.org/releases/v1.17.7/",
      imgAltText: "Sinon",
      imgSrc: L_IMG.L_SINON,
      skillName: "Sinon",
    },
    {
      link: "https://mochajs.org/",
      imgAltText: "Mocha",
      imgSrc: L_IMG.L_MOCHA,
      skillName: "Mocha",
    },
    {
      link: "https://karma-runner.github.io/5.2/index.html",
      imgAltText: "Karma",
      imgSrc: L_IMG.L_KARMA,
      skillName: "Karma",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_IMG.L_GIT,
      skillName: "GIT",
    },
  ],
};
